export function LoadStylesheet({ body, global }: { body: string, global?: boolean | null }) {
    const stylesheet = new CSSStyleSheet();
    stylesheet.replaceSync( body );

    if( global === true ) {
        if( !document.adoptedStyleSheets ) document.adoptedStyleSheets = [];
        document.adoptedStyleSheets.push( stylesheet );
    }

    return stylesheet;
}